import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";
import InverterDetailTable from "../../../../Components/InverterDetailTable/InverterDetailTable";

const ProjectSiteInverterDetailSection = ({
  defaultFormProps,
  formConfig,
  permissions,
  isCreator,
  projectId,
}) => {
  if (!permissions?.canView) {
    return null;
  }

  return (
    <FormSectionWrapper collapsible title="Project Site: Work Areas">
      <InverterDetailTable
        //defaultFormProps={defaultFormProps}
        permission={permissions}
        projectId={projectId}
        isCreator={isCreator}
      />
    </FormSectionWrapper>
  );
};

export default ProjectSiteInverterDetailSection;
